import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import { fetchUltraVoucher, fetchSyncData } from 'actions/UltraVouchers'
import UltraVoucherView from 'components/pages/ultraVouchers/products/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'

export function mapStateToProps(state) {
  const {
    isFetching,
    dataUltraVoucher,
    metaUltraVoucher,
  } = state.root.ultraVoucher

  return {
    isFetching,
    dataUltraVoucher,
    metaUltraVoucher,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchUltraVoucher: bindActionCreators(fetchUltraVoucher, dispatch),
  fetchSyncData: bindActionCreators(fetchSyncData, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('stateSearch', 'setStateSearch', {}),
  withHandlers({
    onLoad: props => (isSearch) => {
      const { page, search } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
      }

      props.fetchUltraVoucher(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),

  withHandlers({
    handleSyncData: props => () => {
      props.fetchSyncData()
    },
    handleSearch: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        search: val.toLowerCase(),
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Ultra Voucher', 'Products'])
      this.props.updateSiteConfiguration('titlePage', 'Ultra Voucher - Products')
      this.props.fetchUltraVoucher()
    },
  }),
)(UltraVoucherView)
